import { CallDetailsComponent } from './containers/call-details/call-details.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { FormLayoutModule } from '../form-layout/form-layout.module';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { CallsWidgetComponent} from '@feature/_app_modules/mojo-calls-widget/containers/mojo-calls-widget.component';
import {BlockUIModule} from 'primeng/blockui';
import {PanelModule} from 'primeng/panel';
import {TabViewModule} from 'primeng/tabview';
import { CallDetailsFormComponent } from './components/call-details-form/call-details-form.component';
import { CardModule } from 'primeng/card';
import { MatListModule } from '@angular/material/list';

@NgModule({
  declarations: [
    CallsWidgetComponent,
    CallDetailsComponent,
    CallDetailsFormComponent
    ],
  exports: [
    CallsWidgetComponent
    ],
  imports: [    
    CommonModule,
    SharedModule,
    TabViewModule,
    FormLayoutModule,
    BlockUIModule,
    PanelModule,
    FormsModule, 
    CardModule,
    ReactiveFormsModule,
    MatListModule
  ]
})

export class CallsWidgetModule { }
